<div class="career-page-container">
  <app-navbar></app-navbar>
  <div class="header d-flexbox">
    <div class="header-content d-flexbox col">
      <div class="btn btn-hover bg-secondary-color">Career</div>
      <div class="big-caption text-default-color">
        Ready to join the <br />
        dream team?
      </div>
      <div class="btn outlined" (click)="jobOpenings()">Explore Open Roles</div>
    </div>
  </div>

  <!--career-intro area after header -->
  <div class="career-intro d-flexbox justify-content-around flex-wrap row" data-aos="zoom-in" data-aos-duration="2000">
    <div class="text-area justify-self-baseline align-self-baseline flex-1" data-aos="fade-left" data-aos-duration="3000">
      <h2 class="caption-primary-color">
        HuiosPay goes for <br />
        nothing but the best
      </h2>
      <p class="text-secondary-color">
        We are equipped to create a work community that pushes everyone to
        believe in themselves and become go-getters. From interns to experts,
        from raw-talented individuals to skilled-talented individuals, all are
        welcome to HuiosPay.
      </p>
    </div>
    <div class="image-area d-flexbox flex-1">
      <img class="img-position" src="../../../../assets/img/c-1.jpeg" alt="" />
    </div>
  </div>

  <!-- We are One -->

  <div class="d-flexbox row justify-content-between flex-wrap" style="margin-top: 50px" data-aos="fade-right" data-aos-duration="3000">
    <div class="image-area d-flexbox flex-1">
      <img src="../../../../assets/img/c-2.jpg" alt="" />
    </div>
    <div class="text-area flex-1" data-aos="fade-up" data-aos-duration="2000">
      <h2 class="caption-primary-color">We are One</h2>
      <p class="text-secondary-color">
        We think as one, work as one, share as one, play as one and win as one.
        Your goals are our goals, your dreams are our dreams, and HuiosPays
        vision is our vision.
      </p>
    </div>
  </div>

  <!-- Love and respect -->

  <div
    class="d-flexbox row justify-content-between flex-wrap "
    style="margin-top: 50px"
    data-aos="fade-left" data-aos-duration="2000"
  >
    <div class="text-area flex-1" data-aos="fade-up" data-aos-duration="2000">
      <h2 class="caption-primary-color">
        It's all love and respect for one another
      </h2>
      <p class="text-secondary-color">
        Love thy neighbor as thy self", one of our prime rule and view towards
        our colleagues. We believe in work fluidity and flexibility due the
        massive love and respect everyone gives to everyone. It's our culture.
      </p>
    </div>
    <div class="image-area d-flexbox flex-1">
      <img src="../../../../assets/img/c-3.jpg" alt="" />
    </div>
  </div>

  <!-- open role -->
  <div class="open-role d-flexbox col page-spacing">
    <h2>No open Role</h2>
    <p>
      There is no current open spot. Once there is a post, it will be  posted here.
      <!-- There is always a spot for you if you're ready to join us in bringing the
      dreams of millions of business to reality. All you need to do is claim it -->
    </p>
    <!-- <div class="d-flexbox row justify-content-between flex-wrap ">
          <div class="flex-2 roles">Marketing</div>
          <div class="flex-2 roles">Tech & Engineering</div>
          <div class="flex-2 roles">Business Development</div>
          <div class="flex-2 roles">Finance</div>
          <div class="flex-2 roles">Design</div>
          <div class="flex-2 roles">Business Operations</div>
          <div class="flex-2 roles">Administration</div>
          <div class="flex-2 roles">Tech & Engineering</div>
          <div class="flex-2 roles">Business Development</div>
          <div class="flex-2 roles">Finance</div>
          <div class="flex-2 roles">Design</div>
          <div class="flex-2 roles">Business Operations</div>
          <div class="flex-2 roles">Administration</div>
  </div> -->
</div>

 <!-- Community section-->
 <app-community-section></app-community-section>
 <!--End Community section-->

 <!-- footer -->
 <app-footer></app-footer>
 <!-- end of footer -->


<app-back-to-top
[acceleration]="2"
[animate]="true"
[scrollDistance]="50"
[speed]="50"
>
</app-back-to-top>
